import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router';
import { Error404 } from '../../composed/error404/Error404';
import "./LoginForm.scss";
import { SignUpDataContext } from '../../context-api/data-provider/SignupDataProvider';
import { getUrlParams } from '../../utils/getUrls';
import { isMobile } from '../../utils/ScreenSizeHelper';
import { Alert } from '@mui/material';
import responseErrorMapping from '../../utils/error.response.mapping';
import InputBox from '../../atomic/inputbox/InputBox';
import AtomicButton from '../../atomic/button/Button';
import { isPassword, isValidEmail } from '../../utils/regexValidation';



const ResetPasswordPage = () => {

    const navigate = useNavigate();
    const [password, setPassword] = useState(undefined);
    const [confirmPassword, setConfirmPassword] = useState(undefined);
    const [isPasswordValid, setIsPasswordValid] = useState(true);
    const [showSuccessAlert, setShowSuccessAlert] = useState(false);
    const [passwordError, setPasswordError] = useState("");
    // const { resetPasswordData, onResetPassword } = useContext(LoginDataContext);
    const { resetPasswordData, setResetPasswordData, onResetPassword } = useContext(SignUpDataContext);
    const { loading, data, success, errorMessage } = resetPasswordData;
    const TryCatchError = errorMessage?.success === false && errorMessage?.CustomMessage === 'Something is seriouly wrong,This is last CATCH block'
    const { token } = getUrlParams()


    const onSubmitHandler = () => {
        if (password !== confirmPassword) {
            setIsPasswordValid(false);
            setPasswordError("Confirm password did not match with password")
        } else if (!isPassword(password) || !isPassword(confirmPassword)) {
            setIsPasswordValid(false);
            setPasswordError("Password should be 8 characters long, with atleast one uppercase letter, one lowercase letter, one number and one special character");
        } else {
            setIsPasswordValid(true);
            onResetPassword(token, { password, retype_password: confirmPassword });
        }

    };

    useEffect(() => {
        if (data && data.data && data.data.success) {
            setShowSuccessAlert(true);
            setTimeout(() => {
                navigate("/login");
            }, 2000);
        }
    }, [data]);



    const showError = !isPasswordValid || success === false;

    if (errorMessage === 'Network Error') {
        return (<Error404 />)
    }


    return <div className={"resetpassword-container-mobile"}>
        <div className="login-form">
            <div className="login-form-title">Reset Password</div>
            <div className="free-text">Free text Free text Free text Free text Free text Free text Free text Free text </div>
            {showError && (
                <Alert
                    severity="error"
                    sx={{ width: "100%", border: "solid 1px red", marginBottom: "5px", marginTop: '10px' }}
                >
                    {(!TryCatchError) && (!isPasswordValid ? <div style={{ color: 'red' }}> {responseErrorMapping(passwordError)}</div> : <div style={{ color: 'red' }}>{responseErrorMapping(errorMessage)}</div>)}

                    {(TryCatchError) && <div style={{ color: 'red', fontSize: '14px' }}>{responseErrorMapping(errorMessage?.CustomMessage)}</div>}
                </Alert>
            )}
            {showSuccessAlert && (
                <Alert
                    severity='success'
                    sx={{
                        width: "100%", border: "2px solid #33AE1C", color: "#33AE1C",
                        marginBottom: "5px", backgroundColor: "white"
                    }}
                >
                    <div>Password Reset Successful</div>
                </Alert>
            )}


            <InputBox
                type="password"
                label="Password"
                size="small"
                sx={{
                    width: '400px',
                    height: "auto",
                    margin: "6px 0px 5px 0px",
                }}
                name="password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}

            />

            <InputBox
                type="password"
                label="Retype Password"
                size="small"
                sx={{
                    width: '400px',
                    height: "auto",
                    margin: "6px 0px 5px 0px",
                }}
                name="confirmpassword"
                value={confirmPassword}
                onChange={(event) => setConfirmPassword(event.target.value)}
            />

            <AtomicButton
                loading={loading}
                handleSubmit={onSubmitHandler}
                label="PASSWORD RESET"
                startIcon={false}
                loadingIcon={false}
                loadingButtonStyle={{}}
                style={{
                    backgroundColor: "rgb(63, 63, 110)",
                    width: '400px',
                    marginTop: "15px",
                    marginBottom: "15px",
                }}
            />

            <div className="login-optional-links" style={{ justifyContent: 'center' }}>

                <span onClick={() => navigate("/login")}>
                    Log In&nbsp;|
                </span>
                <span onClick={() => navigate("/forgotpassword")}>
                    &nbsp;
                    Forgot Password
                </span>


            </div>
        </div>

    </div>
}

export default ResetPasswordPage